import REGISTER from "../assets/images/register.png";
import Checkbox from "antd/es/checkbox/Checkbox";
import {NavLink, useHistory} from "react-router-dom";
import {useState} from "react";
import $ from 'jquery';
import {toast} from "react-toastify";
import {Eye, EyeOff} from "react-feather";
import API_LINK from "../components/links/Link";
import {Radio, Select} from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import {BiEnvelope, BiLogoFacebook, BiLogoInstagram, BiLogoLinkedin, BiMenu, BiX} from "react-icons/bi";
import {BACKGROUND, LOGO} from "./assets/images/Images";

export default function Register() {
    const [isVisible, setIsVisible] = useState(false)
    const history = useHistory();
    const [radioCheck, setRadioCheck] = useState('1');
    const [isReCaptcha, setIsReCaptcha] = useState('')
    const [companyOperations, setCompanyOperations] = useState(null)
    const [sector, setSector] = useState(null)
    const onCheckboxChange = (e) => {
        console.log(`checked = ${e.target.checked}`);
    };

    function onChange(value) {
        console.log("Captcha value:", value);
        setIsReCaptcha(value);
    }

    async function submitHandle(event) {
        event.preventDefault();
        event.stopPropagation();
        var form = $('.RegisterForm');
        let formdata = new FormData(form[0]);
        let toaster;
        if (!form[0].checkValidity()) {
            toast.warn("Fill all the required(*) fields.")
        } else if (!form.find('input[name="email"]').val().includes("@")) {
            toast.warn("Please enter a valid email address");
        } else if (form.find('input[name="password"]').val().length <= 7) {
            toast.warn("Password must contains at least 8 digits");
        } else if (!isReCaptcha) {
            toast.warn("Please fill the recaptcha to confirm you are not a robot.");
        } else {

            form.find("button").attr("disabled", true);
            toaster = toast.loading("Processing...");
            try {
                formdata.append("page", "CreateUser");
                formdata.append("operations", companyOperations);
                formdata.append("sector", sector);

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    redirect: 'follow'
                };

                await fetch(`${API_LINK}Authentication.php`, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        console.log(result);
                        if (result.status === 1) {
                            setTimeout(() => {
                                toast.update(toaster, {
                                    type: "success",
                                    render: "Account have been created successfully.",
                                    isLoading: false,
                                    autoClose: toaster,
                                    closeButton: true,
                                    pauseOnHover: false,
                                    pauseOnFocusLoss: false,
                                })
                                // toast.info("We have shared a verification email.Please make sure to verify your account.");
                                form.find("button").attr("disabled", false);
                                form.trigger("reset");
                                history.push("/");
                            }, 1000)
                        } else if (result.status === 2) {
                            form.find("button").attr("disabled", false);
                            toast.update(toaster, {
                                type: "info",
                                render: "An account with this email already exist. Please login into that account or use other email address.",
                                isLoading: false,
                                autoClose: toaster,
                                closeButton: true,
                                pauseOnHover: false,
                                pauseOnFocusLoss: false,
                            })

                        } else {
                            toast.error("Server Error! Please try again later.")
                        }
                    })
                    .catch(error => console.log('error', error));
            } catch (e) {
                console.log(e);
            }

        }

    }

    return (
        <>
        
            <div className='auth-container' style={{justifyContent: "center"}}>

            <div className="topbar-container">
                    <ul className={'social-list'}>
                        <li>
                            <a href="mailto:info@1solardirect.com">
                                <BiEnvelope />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.facebook.com/1Solardirect/">
                                <BiLogoFacebook />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/1solardirect/">
                                <BiLogoInstagram />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/1-solar-direct/about/">
                                <BiLogoLinkedin />
                            </a>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <a href="https://1solardirect.com/contact-us/">Contact Us</a>
                        </li>
                        <li>
                            <a href="https://1solardirect.com/contact-us/">Get Your Quote</a>
                        </li>
                        <li>
                            <a href="mailto:info@1solardirect.com">Quick Help</a>
                        </li>
                    </ul>
                </div>
                <div className="menu-container">
                <a href="https://1solardirect.com/">
                        <img src={LOGO} alt="Company Logo" className="logo" />
                    </a>
                    <button className="hamburger-menu" onClick={() => {
                        document.getElementById('menu').classList.toggle('show');
                    }}>
                        <BiMenu/>
                    </button>
                    <div className="menu" id={'menu'}>
                        <button className="hamburger-menu hamburger-menu-close" onClick={() => {
                            document.getElementById('menu').classList.toggle('show');
                        }}>
                            <BiX/>
                        </button>
                        <ul className="navlist">
                        <li>
                                <a href="https://1solardirect.com/">Home</a>
                            </li>
                            <li>
                                <a href="https://1solardirect.com/about-us/">About Us</a>
                            </li>
                            <li>
                                <a href="https://1solardirect.com/check-inventory/">Check Inventory</a>
                            </li>
                            <li>
                                <a href="https://1solardirect.com/our-products/">Our Products</a>
                            </li>
</ul>

<style>
  {`
    .navlist a {
      color: #000 !important;
      text-decoration: none;
      transition: color 0.3s ease-in-out;
    }

    .navlist a:hover {
      color: #F99F1D !important;
    }

    /* Ensure styling applies on mobile as well */
    @media (max-width: 768px) {
      .navlist a {
        color: white !important;
      }

      .navlist a:hover {
        color: #F99F1D !important;
      }
    }
  `}
</style>


                        <a href="https://dashboard.1solardirect.com/" className={'menu-btn'}>Login / Register</a>
                    </div>
                </div>
                {/*<div className="auth-image">*/}
                {/*    <img src={REGISTER} loading={"lazy"} alt="Login Image"/>*/}
                {/*</div>*/}
                <div className="auth-form register-form-container" data-aos='fade-left'>
                    <h4 className="title" style={{marginTop: 50, textAlign: "center"}}>Request Your 1SolarDirect
                        Account.</h4>
                    {/*<h4 className="title"*/}
                    {/*    style={{*/}
                    {/*        fontSize: 20,*/}
                    {/*        fontWeight: 600,*/}
                    {/*        lineHeight: 'initial',*/}
                    {/*        marginBottom: 20,*/}
                    {/*        textAlign: "center"*/}
                    {/*    }}>Request Your*/}
                    {/*    1SolarDirect Account</h4>*/}
                    <div className="header_text_center">
                        <p style={{fontSize: 14, marginBottom: 30, marginTop: 18, textAlign: "center"}}>We’ll verify your
                            company information within 2-3 business days. <br/> 
                            Once approved, you’ll receive an email confirmation with full access to our available
                            inventory.</p>
                    </div>
                    <form noValidate className='RegisterForm' onSubmit={submitHandle}>
                        <div className="register-form">
                            <div className="form-heading">
                                <h2>Username & Password</h2>
                            </div>
                            <div className="form-group">
                                <input type="text" required placeholder={'Username*'}
                                       name={'username'}/>
                                        <span style={{fontSize: '10px', marginLeft: 20}}>Username cannot be changed.</span>
                            </div>
                            <div className="form-group">
                                {/*<label>Password <code>*</code></label>*/}
                                <input type={isVisible ? "text" : "password"} required placeholder={'Password*'}
                                       name={'password'}/>
                                        <span style={{fontSize: '10px', marginLeft: 20}}>Type your password. Minimum length of 8 characters, with one uppercase letter (A-Z).
                                        </span>
                                <button type={"button"} onClick={() => setIsVisible(!isVisible)} className='btn_eye'>
                                    {
                                        isVisible ?
                                            <EyeOff/> :
                                            <Eye/>
                                    }
                                </button>
                            </div>
                            <div className="form-heading">
                                <h2>Contact Information</h2>
                            </div>

                            <div className="form-group">
                                {/*<label>First Name <code>*</code></label>*/}
                                <input type="text" required placeholder={'First Name*'}
                                       name={'firstname'}/>
                            </div>
                            <div className="form-group">
                                {/*<label>Last Name <code>*</code></label>*/}
                                <input type="text" required placeholder={'Last Name*'}
                                       name={'lastname'}/>
                            </div>
                            <div className="form-group">
                                {/*<label>Email address <code>*</code></label>*/}
                                <input type="text" required placeholder={'Email Address*'} name={'email'}/>
                            </div>
                            <div className="form-group">
                                {/*<label>Phone Number <code>*</code></label>*/}
                                <input type="number" required placeholder={'Phone Number*'}
                                       name={'phone'}/>
                                <span style={{fontSize: '10px', marginLeft: 20}}>Required phone number format: (###) ###-####</span>
                            </div>
                            <div className="form-group" style={{marginTop: -4}}>
                                {/*<label>TimeZone</label>*/}
                                <select name="timezone" id="user_timezone">
                                    <option value="" className="custom_field_select_option " disabled=""
                                            selected="">Time zone
                                    </option>
                                    <option value="(GMT -12:00) Eniwetok, Kwajalein">(GMT -12:00) Eniwetok, Kwajalein
                                    </option>
                                    <option value="(GMT -11:00) Midway Island, Samoa">(GMT -11:00) Midway Island,
                                        Samoa
                                    </option>
                                    <option value="(GMT -10:00) Hawaii">(GMT -10:00) Hawaii</option>
                                    <option value="(GMT -9:00) Alaska">(GMT -9:00) Alaska</option>
                                    <option value="(GMT -8:00) Pacific Time (US &amp; Canada)">(GMT -8:00) Pacific Time
                                        (US &amp; Canada)
                                    </option>
                                    <option value="(GMT -7:00) Mountain Time (US &amp; Canada)">(GMT -7:00) Mountain
                                        Time (US &amp; Canada)
                                    </option>
                                    <option value="(GMT -6:00) Central Time (US &amp; Canada), Mexico City"
                                            selected>(GMT -6:00) Central Time (US &amp; Canada), Mexico City
                                    </option>
                                    <option value="(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima">(GMT -5:00)
                                        Eastern Time (US &amp; Canada), Bogota, Lima
                                    </option>
                                    <option value="(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz">(GMT -4:00)
                                        Atlantic Time (Canada), Caracas, La Paz
                                    </option>
                                    <option value="(GMT -3:30) Newfoundland">(GMT -3:30) Newfoundland</option>
                                    <option value="(GMT -3:00) Brazil, Buenos Aires, Georgetown">(GMT -3:00) Brazil,
                                        Buenos Aires, Georgetown
                                    </option>
                                    <option value="(GMT -2:00) Mid-Atlantic">(GMT -2:00) Mid-Atlantic</option>
                                    <option value="(GMT -1:00) Azores, Cape Verde Islands">(GMT -1:00) Azores, Cape
                                        Verde Islands
                                    </option>
                                    <option value="(GMT) Western Europe Time, London, Lisbon, Casablanca">(GMT) Western
                                        Europe Time, London, Lisbon, Casablanca
                                    </option>
                                    <option value="(GMT +1:00) Brussels, Copenhagen, Madrid, Paris">(GMT +1:00)
                                        Brussels, Copenhagen, Madrid, Paris
                                    </option>
                                    <option value="(GMT +2:00) Kaliningrad, South Africa">(GMT +2:00) Kaliningrad, South
                                        Africa
                                    </option>
                                    <option value="(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg">(GMT +3:00)
                                        Baghdad, Riyadh, Moscow, St. Petersburg
                                    </option>
                                    <option value="(GMT +3:30) Tehran">(GMT +3:30) Tehran</option>
                                    <option value="(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi">(GMT +4:00) Abu Dhabi,
                                        Muscat, Baku, Tbilisi
                                    </option>
                                    <option value="(GMT +4:30) Kabul">(GMT +4:30) Kabul</option>
                                    <option value="(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent">(GMT +5:00)
                                        Ekaterinburg, Islamabad, Karachi, Tashkent
                                    </option>
                                    <option value="(GMT +5:30) Bombay, Calcutta, Madras, New Delhi">(GMT +5:30) Bombay,
                                        Calcutta, Madras, New Delhi
                                    </option>
                                    <option value="(GMT +5:45) Kathmandu">(GMT +5:45) Kathmandu</option>
                                    <option value="(GMT +6:00) Almaty, Dhaka, Colombo">(GMT +6:00) Almaty, Dhaka,
                                        Colombo
                                    </option>
                                    <option value="(GMT +7:00) Bangkok, Hanoi, Jakarta">(GMT +7:00) Bangkok, Hanoi,
                                        Jakarta
                                    </option>
                                    <option value="(GMT +8:00) Beijing, Perth, Singapore, Hong Kong">(GMT +8:00)
                                        Beijing, Perth, Singapore, Hong Kong
                                    </option>
                                    <option value="(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk">(GMT +9:00) Tokyo,
                                        Seoul, Osaka, Sapporo, Yakutsk
                                    </option>
                                    <option value="(GMT +9:30) Adelaide, Darwin">(GMT +9:30) Adelaide, Darwin</option>
                                    <option value="(GMT +10:00) Eastern Australia, Guam, Vladivostok">(GMT +10:00)
                                        Eastern Australia, Guam, Vladivostok
                                    </option>
                                    <option value="(GMT +11:00) Magadan, Solomon Islands, New Caledonia">(GMT +11:00)
                                        Magadan, Solomon Islands, New Caledonia
                                    </option>
                                    <option value="(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka">(GMT +12:00)
                                        Auckland, Wellington, Fiji, Kamchatka
                                    </option>
                                </select>
                            </div>
                            <div className="form-heading">
                                <h2>Receive Latest Deals <code style={{color: "red"}}>*</code></h2>
                            </div>
                            <div className="radio-group">
                                <Radio.Group value={radioCheck} onChange={(e) => setRadioCheck(e.target.value)}>
                                    <Radio value={'1'}>Sign me up!</Radio>
                                    <Radio value={'2'}>No thanks</Radio>
                                </Radio.Group>
                                <p>Sign me up for exclusive emails from 1SolarDirect! Your privacy is our priority — we’ll
                                    never share your information. We typically send one or two emails a week, depending
                                    on inventory. If you ever want to unsubscribe, every email gives you the option —
                                    it's quick and easy.</p>
                            </div>
                            <div className="form-heading">
                                <h2>Billing Information</h2>
                            </div>
                            <div className="form-group">
                                {/*<label>Company Name <code>*</code></label>*/}
                                <input type="text" required placeholder={'Company Name*'} name={'company'}/>
                            </div>
                            <div className="form-group">
                                {/*<label>Address Line 1 <code>*</code></label>*/}
                                <input type="text" required placeholder={'Address line 1*'} name={'address'}/>
                            </div>
                            <div className="form-group">
                                {/*<label>Address Line 2 </label>*/}
                                <input type="text" placeholder={'Address line 2'}/>
                            </div>
                            <div className="form-group">
                                {/*<label>City <code>*</code></label>*/}
                                <input type="text" required placeholder={'City*'} name={'city'}/>
                            </div>

                            <div className="form-group">
                                {/*<label>Zip Code <code>*</code></label>*/}
                                <input type="text" required placeholder={'Zip Code*'} name={'zip'}/>
                            </div>
                            <div className="form-group">
                                {/*<label>State</label>*/}
                                <select name="state" id="billing_state">
                                    <option value="" selected="">Select State</option>
                                    <option value="AL">Alabama</option>
                                    <option value="AK">Alaska</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DE">Delaware</option>
                                    <option value="DC">District Of Columbia</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option value="HI">Hawaii</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="IA">Iowa</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="ME">Maine</option>
                                    <option value="MD">Maryland</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MT">Montana</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NY">New York</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VT">Vermont</option>
                                    <option value="VA">Virginia</option>
                                    <option value="WA">Washington</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WY">Wyoming</option>
                                    <option value="AA">Armed Forces (AA)</option>
                                    <option value="AE">Armed Forces (AE)</option>
                                    <option value="AP">Armed Forces (AP)</option>
                                </select>
                            </div>
                            <div className="form-group">
                                {/*<label>Country <code>*</code></label>*/}
                                <select name="country" id="country">
                                    <option value="" selected="">Select an option…</option>
                                    <option value="PR">Puerto Rico</option>
                                    <option value="US" selected>United States (US)</option>
                                    <option value="UM">United States (US) Minor Outlying Islands</option>
                                </select>
                            </div>
                            <div className="form-group">
                                {/*<label>Company Website <code>*</code></label>*/}
                                <input type="text" required placeholder={'Company Website*'} name={'website'}/>
                            </div>

                            <div className="form-group">
                                {/*<label>Business Activities</label>*/}
                                <Select
                                    mode="multiple"
                                    size={'large'}
                                    showArrow={false}
                                    variant={"outlined"}
                                    placeholder="Company Operations *"
                                    onChange={(value) => {
                                        setCompanyOperations(value);
                                    }}
                                    options={[
                                        {
                                            label: "Asset Owner",
                                            value: "Asset Owner"
                                        },

                                        {
                                            label: "EPC",
                                            value: "EPC"
                                        },

                                        {
                                            label: "Solar Installer",
                                            value: "Solar Installer"
                                        },
                                        {
                                            label: "Manufacturer",
                                            value: "Manufacturer"
                                        },
                                        {
                                            label: "Developer",
                                            value: "Developer"
                                        },
                                        {
                                            label: "Operations & Maintenance",
                                            value: "Operations & Maintenance"
                                        },
                                        {
                                            label: "Utilities Scale",
                                            value: "Utilities Scale"
                                        },
                                    ]}
                                />
                            </div>
                            <div className="form-group">
                                {/*<label>Sector</label>*/}
                                <Select
                                    mode="multiple"
                                    size={'large'}
                                    showArrow={false}
                                    variant={"outlined"}

                                    placeholder="Solar Sector *"
                                    onChange={(value) => {
                                        setSector(value);
                                    }}
                                    options={[
                                        {
                                            label: "Residential",
                                            value: "Residential"
                                        },
                                        {
                                            label: "Commercial",
                                            value: "Commercial"
                                        },
                                        {
                                            label: "Utility",
                                            value: "Utility"
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <ReCAPTCHA
                                sitekey="6LdBYKAqAAAAAHZPwOoSW17wGygO6C-M4thIbZsl"
                                onChange={onChange}
                                onExpired={() => setIsReCaptcha("")}
                                onErrored={() => setIsReCaptcha("")}
                            />
                        </div>
                        <div className="form-group space-between-content">
                            <Checkbox onChange={onCheckboxChange}>Send these credentials via email.</Checkbox>
                        </div>
                        <div className="form-group">
                            <button type={"submit"} className='btn-login'>Register</button>
                        </div>
                        <div className="form-group">
                            <div className="row-item">
                                <span>Already have an account? </span><NavLink to={'/'}>Login</NavLink>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </>
    )
}
